
<template>
  <v-container
    fluid
    :grid-list-md="!isMobile"
    :grid-list-sm="isMobile">
    <v-layout 
     
      row 
      wrap>
      <v-flex
        v-for="cat in categories"
        :key="cat.title"
        xs6
        text-xs-center>
        <v-btn 
          :color="cat.color"
          :outline="!selectedCats.includes(cat.title.toString())"
          style="width: 120px; margin-bottom: 0;" 
          dark
          :style="isMobile ? 'height: 32px' : ''"
          @click="selectedCats = cat.title">
          <v-icon 
            left>
            {{ cat.icon }}
          </v-icon>{{ cat.title }}
        </v-btn>
      </v-flex>
    </v-layout>
    <v-layout class="text-xs-center pt-3 px-4">
      <v-flex xs12>
        <article class="font-italic primary--text">
          <!-- TODO: Text/Translate -->

          {{ noneCatsSelected ? 'Mindestens eine Kategorie muss gewählt sein!' : 'Wähle deine Kategorien!' }}
        </article>
      </v-flex>
    </v-layout>
    <v-layout
      class="mt-1 mb-5"
      row
      wrap
      justify-center>
      <v-flex
        xs12
        class="text-xs-center">
        <v-btn
          color="green lighten-1"
          dark
          small
          style="min-width: 200px"
          @click="selectAll">
          <v-icon left>
            fas fa-check-square
          </v-icon>
          <!-- TODO: Text/Translate -->

          Alle auswählen
        </v-btn>
      </v-flex>
      <v-flex
        xs12
        class="text-xs-center">
        <v-btn
          color="red lighten-1"
          dark
          small
          style="min-width: 200px"

          @click="selectNone">
          <v-icon left>
            far fa-times-square
            <!-- TODO: Text/Translate -->
          </v-icon>Alle abwählen
        </v-btn>
      </v-flex>
      <!-- {{ selectedCats }} -->
    </v-layout>
  </v-container>
</template>


<script>
import { mapState, mapMutations } from 'vuex'
import { union } from 'lodash'

export default {
  data() {
    return {
    }
  },
  computed: {
    ...mapState({
      timelineFilter: state => state.timeline.timelineFilter,
      user: state => state.user.user,
      isMobile: state => state.isMobile,
      categories: state => state.categories,
    }),
   
    selectedCats: {
      get() {
        return this.timelineFilter.categoriesFilter
      },
      set(catTitle) {
        if (this.timelineFilter.categoriesFilter.includes(catTitle.toString())) {
          let filteredAry = this.timelineFilter.categoriesFilter.filter(cat => cat !== catTitle)
          this.setFilter({ categoriesFilter: filteredAry })
        } else {
          let filteredAry = union(this.timelineFilter.categoriesFilter, [
            catTitle
          ])
          this.setFilter({ categoriesFilter: filteredAry })
        }
      }
    },

    noneCatsSelected() {
      if (typeof this.selectedCats !== 'undefined' && this.selectedCats.length > 0) {
        return false
      } else {
        return true
      }
    },
  },

  
  methods: {
    ...mapMutations([
      'setFilter',
      'setCategoriesFilter'
    ]),

    selectAll() {
      let allAry = []

      for (const key of Object.keys(this.categories)) {
        allAry.push(key)
      }
      this.setFilter({ categoriesFilter: allAry })

    },

    selectNone() {
      let allAry = []

     
      this.setFilter({ categoriesFilter: allAry })
    }

  }
}
</script>
